import React from 'react';
import { Flex, Button } from '../design-system';
import { FaRegEdit } from 'react-icons/fa';
import DeleteButton from './DeleteButton';

interface EditAndDeleteProps {
  row: { original: Record<string, any> };
  cell: { value: (id: any) => void };
  alignRight?: boolean;
}

const EditAndDelete = ({
  row: { original },
  cell: { value: handleDelete },
  alignRight,
}: EditAndDeleteProps) => {
  const { canEdit, id, openEditModal } = original;
  return canEdit ? (
    <Flex justifyContent={alignRight && 'flex-end'}>
      <Button
        id="edit-button"
        title="Edit"
        type="button"
        aria-label="Edit Item"
        variant="primaryText"
        onClick={() => openEditModal(original)}
      >
        <FaRegEdit fontSize={20} />
      </Button>
      <DeleteButton onClick={() => handleDelete(id)} />
    </Flex>
  ) : null;
};
export default EditAndDelete;
